export default __webpack_public_path__ + "static/media/logo.2a4a02b6.png";